import React from 'react';
import { regulatoryReferencesAPI } from '../api/client';
import LookupMultiSelect from './LookupMultiSelect';

/** Active Regulatory References. Used by DocumentModal and TemplateModal. */
function RegulatoryReferenceMultiSelect({ selectedIds, onChange }) {
  return (
    <LookupMultiSelect
      fetchItems={() => regulatoryReferencesAPI.getSelectable()}
      selectedIds={selectedIds}
      onChange={onChange}
      placeholder="All regulatory references"
      emptyMessage="No regulatory references defined yet. Add one under Admin → Regulatory References."
    />
  );
}

export default RegulatoryReferenceMultiSelect;
